var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "Status" }, [
    _c(
      "section",
      [
        _c(
          "v-row",
          { attrs: { variant: "flex" } },
          [
            _c("v-column", { attrs: { large: 12 } }, [
              _c(
                "ul",
                _vm._l(_vm.listOfRoutes, function(route, routeIndex) {
                  return _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          key: "menu-link-" + routeIndex,
                          staticClass: "header__link",
                          attrs: {
                            to: _vm.path(
                              route.name
                                ? route.name.replace("-cs", "")
                                : "index"
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n\n\t\t\t\t\t\t\t" +
                              _vm._s(route.name) +
                              "\n\n\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }